import _string from 'lodash/string';

const fileMimeType = {
  pdf: 'application/pdf',
  xlsx: 'application/vnd.ms-excel',
  jpeg: 'image/jpeg',
  jpg: 'image/jpeg',
  png: 'image/png',
  csv: 'text/csv;charset=utf-8',
  doc: 'application/msword',
};

export default {
  download(data, fileName) {
    const fileNameSplit = _string.split(fileName, '.');
    const extension = fileNameSplit[fileNameSplit.length - 1];
    let mimeType = 'application/pdf';
    if (fileMimeType[extension]) {
      mimeType = fileMimeType[extension];
    }
    const file = new Blob([data], { type: mimeType });
    const anchor = document.createElement('a');
    if (window.navigator.msSaveBlob) { // IE
      window.navigator.msSaveOrOpenBlob(file, fileName);
    } else { // Chrome
      anchor.href = URL.createObjectURL(file);
      anchor.download = fileName;
      anchor.click();
    }
  },
  downloadExcel(data, fileName) {
    const fileNameSplit = _string.split(fileName, '.');
    const extension = fileNameSplit[fileNameSplit.length - 1];
    let mimeType = 'application/vnd.ms-excel';
    if (fileMimeType[extension]) {
      mimeType = fileMimeType[extension];
    }
    const file = new Blob([data], { type: mimeType });
    const anchor = document.createElement('a');
    if (window.navigator.msSaveBlob) { // IE
      window.navigator.msSaveOrOpenBlob(file, fileName);
    } else { // Chrome
      anchor.href = URL.createObjectURL(file);
      anchor.download = fileName;
      anchor.click();
    }
  },
};


// WEBPACK FOOTER //
// ./src/assets/services/downloadService.js